import { CheckingAccountFormComponent } from '../../../../forms/dynamic-forms/profile-settings-forms/checking-account-form/checking-account-form.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { AcmicService } from '@mapfre-design-library/src/public_api';
import { CheckingAccountService } from '../../../../../_services/forms/profile-settings/checking-account.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CheckingAccountFormComponent],
  selector: 'app-profile-checking-account',
  templateUrl: './profile-checking-account.component.html',
  providers: [CheckingAccountService],
})
export class ProfileCheckingAccountComponent implements OnInit {
  checkingAccountForm: any[];
  whereInTheProcess: string;
  policyId: string;
  isAcmic = false;

  constructor(
    private checkingAccountService: CheckingAccountService,
    private activatedRoute: ActivatedRoute,
    private acmicService: AcmicService
  ) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.whereInTheProcess = this.activatedRoute.snapshot.routeConfig.path;
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });
    this.checkingAccountService
      .getInputs(this.policyId)
      .subscribe((inputsResponse) => {
        this.checkingAccountForm = inputsResponse;
      });
  }


}
